// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "slide-zZAFy";
var _3 = "slide__wrapper-2Vmd3";
var _4 = "content-nLWB2";
var _5 = "header-1Cu33";
var _6 = "main-2Z2yH";
var _7 = "main__icon-7GBEf";
var _8 = "price__wrapper-2yyL2";
var _9 = "money-2AFdN";
var _a = "controls-vSsEJ";
var _b = "control-364iz";
var _c = "control_selected-3bVTx";
var _d = "control_free-fnbOh";
var _e = "actions-2uzaT";
var _f = "cancel-3V7i2";
var _10 = "confirm-3Yi8F";
export { _1 as "__esModule", _2 as "slide", _3 as "slide__wrapper", _4 as "content", _5 as "header", _6 as "main", _7 as "main__icon", _8 as "price__wrapper", _9 as "money", _a as "controls", _b as "control", _c as "control_selected", _d as "control_free", _e as "actions", _f as "cancel", _10 as "confirm" }
export default { "__esModule": _1, "slide": _2, "slide__wrapper": _3, "content": _4, "header": _5, "main": _6, "main__icon": _7, "price__wrapper": _8, "money": _9, "controls": _a, "control": _b, "control_selected": _c, "control_free": _d, "actions": _e, "cancel": _f, "confirm": _10 }
